module.exports = __webpack_public_path__ + "img/christmas.725555e2.png";